<template>
  <div v-if="logos && logos.length" class="sponsor-logos">
    <div
      v-for="logo in logos"
      :key="logo.key"
      class="logo"
      :style="{ maxWidth: logo.maxWidth + 'px' }"
    >
      <p>{{ logo.heading }}</p>
      <img :src="logo.src" :alt="alt" class="img-responsive" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  inject: ['lang'],
  props: {
    from: {
      type: String,
      required: true
    }
  },
  computed: {
    logos() {
      return this.sponsors[this.from].images;
    },
    alt() {
      return this.lang.get('entries.form.sponsor_logo');
    },
    ...mapGetters('entryForm', ['sponsors'])
  }
};
</script>
